import * as React from "react"
import type { SVGProps } from "react"
const SvgTextBold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.8 19.29q-.83 0-1.41-.6a2 2 0 0 1-.59-1.4v-10q0-.82.59-1.42A2 2 0 0 1 8.8 5.3h3.53a5 5 0 0 1 3 1q1.37 1 1.37 2.77 0 1.27-.57 1.96a5 5 0 0 1-1.08 1q.63.26 1.39 1.02.76.75.76 2.25 0 2.23-1.62 3.1a6.4 6.4 0 0 1-3.05.9zm1.02-2.8h2.6q1.2 0 1.47-.62.26-.6.26-.88t-.26-.9-1.54-.6H9.82zm0-5.7h2.33q.82 0 1.2-.43a1.4 1.4 0 0 0 .38-.95q0-.6-.43-.97a1.6 1.6 0 0 0-1.1-.38H9.83z" />
  </svg>
)
export default SvgTextBold
